import get from 'lodash/get';
import { MitraState } from '../States';
import { MitraTypes } from '../Types';
import { updateState } from '../Store';

export default function MitraReducer(state = MitraState, action) {
  switch (action.type) {
    case MitraTypes.SET_ERROR:
      return { ...state, error: get(action, 'payload.error') };
    case MitraTypes.SET_INFO:
      return { ...state, info: get(action, 'payload.info') };
    case MitraTypes.SET_SUCCESS_MESSAGE:
      return { ...state, success: get(action, 'payload.success') };
    case MitraTypes.RESET_ERROR:
      return { ...state, error: {} };
    case MitraTypes.RESET_INFO:
      return { ...state, info: {} };
    case MitraTypes.RESET_SUCCESS_MESSAGE:
      return { ...state, success: {} };
    case MitraTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case MitraTypes.SET_MITRA_DETAILS:
      return updateState(state, { selectedMitraDetails: action.payload });
    case MitraTypes.SET_JOB_DESCRIPTION:
      return updateState(state, { selectedJobDescription: action.payload });
    case MitraTypes.SET_JOB_LISTINGS_CAROUSEL_CONTENT:
      return updateState(state, { jobListingCarouselContent: action.payload });
    default:
      return state;
  }
}
